const defaultState = {
  bookingList: {},
  error: "",
  isRequest: false,
};

const bookingReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "BOOKING_LIST_REQUEST":
      return {
        isRequest: true,
      };
    case "BOOKING_LIST_REQUEST_SUCCESS":
      return {
        isRequest: false,
        bookingList: action.payload,
      };
    case "BOOKING_LIST_REQUEST_FAILED":
      return {
        isRequest: false,
        erros: action.payload.message,
      };
    default:
      return state;
  }
};

export default bookingReducer;



// WEBPACK FOOTER //
// src/store/reducers/booking.js